<script>
  // The one notification style: white card, brand shadow, a coloured icon for the kind, top right.
  import { fly } from 'svelte/transition';
  import { CheckCircleSolid, ExclamationCircleSolid, InfoCircleSolid, CloseOutline } from 'flowbite-svelte-icons';
  import { toasts, dismissToast } from '$service/toast';

  const ICON = { success: CheckCircleSolid, error: ExclamationCircleSolid, info: InfoCircleSolid };
  const TONE = { success: 'text-emerald-600', error: 'text-[#f34857]', info: 'text-[#5266eb]' };
</script>

<div class="fixed top-4 right-4 left-4 sm:left-auto sm:w-[380px] flex flex-col gap-2 z-[100] pointer-events-none" aria-live="polite">
  {#each $toasts as t (t.id)}
    <div
      role={t.kind === 'error' ? 'alert' : 'status'}
      class="sc-toast pointer-events-auto flex items-start gap-3 pl-4 pr-2 py-3 rounded-xl bg-white dark:bg-gray-800 border border-[#e0e5ed] dark:border-gray-700 text-sm text-navy dark:text-gray-100 font-geist"
      in:fly={{ y: -12, duration: 180 }}
      out:fly={{ x: 24, duration: 160 }}
    >
      <svelte:component this={ICON[t.kind] ?? InfoCircleSolid} class="w-5 h-5 flex-shrink-0 {TONE[t.kind] ?? TONE.info}" />
      <span class="flex-1 min-w-0 pt-px break-words">{t.message}</span>
      <button type="button" class="flex-shrink-0 p-0.5 rounded text-[#637086] hover:text-navy dark:hover:text-white" aria-label="Dismiss" on:click={() => dismissToast(t.id)}><CloseOutline class="w-4 h-4" /></button>
    </div>
  {/each}
</div>

<style>
  .sc-toast { box-shadow: 0 8px 24px -6px rgba(5, 12, 59, 0.16), 0 0 0 1px rgba(5, 12, 59, 0.03); }
</style>
